import axios from "axios";

// State shared between the React bridge and the auth sagas, so sign-out can run in a fixed order:
// unregister the device -> revoke the session -> clear local state -> tell the native shell.
const REGISTERED_KEY = "anike:push-registered";
const UNREGISTER_TIMEOUT_MS = 5000;

let device = null;

export const postToNative = message => {
  const bridge = typeof window !== "undefined" && window.ReactNativeWebView;
  if (bridge && typeof bridge.postMessage === "function") {
    bridge.postMessage(JSON.stringify({ source: "anike-web", v: 1, ...message }));
  }
};

export const registeredKey = {
  get: () => {
    try { return localStorage.getItem(REGISTERED_KEY); } catch (e) { return null; }
  },
  set: value => {
    try { localStorage.setItem(REGISTERED_KEY, value); } catch (e) { /* storage unavailable */ }
  },
  clear: () => {
    try { localStorage.removeItem(REGISTERED_KEY); } catch (e) { /* storage unavailable */ }
  }
};

export const setDevice = value => {
  device = value;
};

export const getDevice = () => device;

// Needs the access token that is still in the store; it never blocks or fails sign-out.
export async function unregisterPushDevice() {
  if (!device) return;
  try {
    await axios.post("/v2/user/push-token/remove", { token: device.token }, { timeout: UNREGISTER_TIMEOUT_MS });
  } catch (e) {
    // offline or already rejected: the server also drops the token when the session is revoked
  }
}

// The session is over (explicit sign-out or the refresh session was refused); never called for a plain token refresh.
export function announceSessionEnded() {
  registeredKey.clear();
  postToNative({ type: "logout" });
}
